<script>
  import Stack from "../../layout/Stack.svelte";
  import {translate} from "../../../i18n/i18next.js";

  export let user
</script>

<Stack direction="vertical" gap=".3rem">
  <span style="font-size: 1.3rem; font-weight: bold">{user.name}</span>
  {#if user?.id}<span style="font-size: .9rem; color: darkgrey">id: {user.id}</span>{/if}
</Stack>
<span>
  {translate("frontend:components.restrictedUserInvitationDialog.steps.manageRestrictions.caption")}
</span>
